'use client';

import {
  TireEfficiencyFlag,
  type TireEfficiencyFlagSpecificProps,
} from '@packages/shared/src/ui/TireEfficiencyFlag/TireEfficiencyFlag';
import type { EfficiencyFlagOverlay } from '@packages/shared/src/ui/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { EfficiencyFlagOverlayDialog } from '@packages/shared/src/ui/EfficiencyFlagOverlayDialog/EfficiencyFlagOverlayDialog';
import { useIntl } from 'react-intl';
import { efficiencyFlagMessages } from '@packages/modules/src/LegacyEfficiencyFlag/messages';

export type ProductCardV2TireEfficiencyFlagsProps = {
  flags: readonly (TireEfficiencyFlagSpecificProps & { overlay?: EfficiencyFlagOverlay })[];
};

export const ProductCardV2TireEfficiencyFlags = ({
  flags,
}: ProductCardV2TireEfficiencyFlagsProps) => {
  const { formatMessage } = useIntl();
  return (
    <div className="flex flex-wrap gap-0.5">
      {flags.map(({ overlay, ...flagProps }, index) => (
        <EfficiencyFlagOverlayDialog key={overlay?.title ?? index} overlay={overlay}>
          {/* leading-none is necessary because the ...OverlayDialog sets the button to line-height:0, which cascades down to the flag itself, for some reason the flag text-size doesn't specify a line-height */}
          <TireEfficiencyFlag
            {...flagProps}
            className="leading-none"
            aria-label={formatMessage(efficiencyFlagMessages[flagProps.type])}
          />
        </EfficiencyFlagOverlayDialog>
      ))}
    </div>
  );
};
